import { useCallback, useMemo } from "react";

import { useGrid } from "../context";

export default function useDefaultEvents() {
  const { store: { collection: { save, deleteEntry } }, handleRefresh } = useGrid()

  const handleUpdateEntry = useCallback(async row => {
    await save(row)
    await handleRefresh()
  }, [save, handleRefresh])

  const handleDeleteEntry = useCallback(async row => {
    await deleteEntry(row, true)
    await handleRefresh()
  }, [deleteEntry, handleRefresh])

  const handleDuplicateEntry = useCallback(async row => {
    row.id = null
    await save(row)
    await handleRefresh()
  }, [save, handleRefresh])

  return useMemo(() => ({
    handleUpdateEntry,
    handleDeleteEntry,
    handleDuplicateEntry,
  }), [handleUpdateEntry, handleDeleteEntry, handleDuplicateEntry])
}
